module.exports = __webpack_public_path__ + "static/media/2.c53a0e53.png";